import { createFileRoute } from '@tanstack/react-router';
import { JourneysIntegrationsHandoff } from '@/pages/workspaces/integrations/routing';

function JourneysIntegrationsWebhooksRoute() {
  return <JourneysIntegrationsHandoff target="webhooks" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/all/webhooks')({
  component: JourneysIntegrationsWebhooksRoute,
});
